<template>
  <div class="flex min-w-72 flex-col md:gap-spacing_9">
    <div
      class="flex flex-col items-center rounded-r2 bg-transparent md:border md:border-neutral-400"
    >
      <template v-if="show_avatar">
        <div class="hidden items-center gap-4 self-start px-6 py-4 md:flex">
          <div v-if="!avatar" class="flex items-center gap-4">
            <Skeleton class="h-[63px] w-[65px] rounded-full" />
            <div class="flex flex-col gap-1">
              <Skeleton class="h-4 w-20" />
              <Skeleton class="h-4 w-28" />
            </div>
          </div>

          <div v-else class="flex items-center gap-4">
            <Avatar :avatar />
            <h1 class="flex flex-col font-primary text-size_5 font-bold">
              <span>{{ $t("common.messages.hi") }},</span>
              <span>{{ avatar }}</span>
            </h1>
          </div>
        </div>

        <Separator class="!hidden w-5/6 md:!flex" />
      </template>

      <div
        v-for="item in accordionItems"
        class="clickable-accordion group flex w-full flex-col items-center"
        :key="item.id"
      >
        <AccordionButton
          class="w-full p-spacing_9 group-first:rounded-t-r2"
          v-bind="item"
          :class="{
            'item-selected border-l border-action rtl:border-r':
              item.isSelected,
          }"
          @select="$emit('select', $event)"
        />

        <Separator class="w-full md:w-5/6 md:group-last:hidden" />
      </div>
    </div>

    <div class="p-spacing_3 md:p-0">
      <CommonButton
        v-if="buttonOptions"
        class="w-fit md:w-full"
        v-bind="buttonOptions"
        :c_style="deleteButtonStyle"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AccordionButtonOption } from "~/types/schemas/common/Molecule/Accordion";
import type { ProfileMenuProps } from "~/types/schemas/User/Organism/ProfileMenu";
import type { ButtonProps } from "~/types/schemas/common/Atom/button";
import Avatar from "~/components/common/Atom/Avatar.vue";
import Separator from "~/components/common/Atom/Separator.vue";
import AccordionButton from "~/components/common/Molecule/AccordionButton.vue";
import CommonButton from "~/components/common/Atom/Button.vue";
import Skeleton from "~/components/common/SkeletonLoader.vue";

defineEmits<{
  select: [item: AccordionButtonOption];
  delete: [];
}>();

defineProps<ProfileMenuProps>();

const nuxtApp = useNuxtApp();

const deleteButtonStyle = computed<ButtonProps["c_style"]>(() =>
  nuxtApp.$device.isDesktop
    ? { name: "main", type: "secondary", style: "B" }
    : { name: "danger", type: "tertiary", style: "A" },
);
</script>

<style scoped>
.clickable-accordion {
  :deep(button) {
    flex: 1;
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
